import { Manufacturer } from "./types";

export const MOCK_MANUFACTURERS: Manufacturer[] = [
  {
    id: "1",
    nameKey: "MANUFACTURERS.DATA.MERCEDES",
    priority: 0,
  },
  {
    id: "2",
    nameKey: "MANUFACTURERS.DATA.MAN",
    priority: 4,
  },
  {
    id: "3",
    nameKey: "MANUFACTURERS.DATA.DAF",
    priority: 6,
  },
  {
    id: "4",
    nameKey: "MANUFACTURERS.DATA.VOLVO",
    priority: 1,
  },
];
